export enum MainBroker {
  Evox = 'EVOX',
  Bayerische = 'BAYERISCHE',
}
